module.exports = __webpack_public_path__ + "img/ngi_logo.2d91dc5c.png";